var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack356({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 3,
    y: 2.96,
    width: 10,
    height: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.5,10.74V5.37h.88l1,3.8.21.8c0-.2.13-.48.24-.86l1-3.74h.79v5.37H7.15V6.25L5.86,10.74H5.34L4.06,6.17v4.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.72,8.64V8h1.86v2a3.34,3.34,0,0,1-.89.62,2.19,2.19,0,0,1-.94.21,2.06,2.06,0,0,1-1.15-.32,2.26,2.26,0,0,1-.8-.94,3.53,3.53,0,0,1-.29-1.49A3.8,3.8,0,0,1,8.8,6.55a2.18,2.18,0,0,1,.78-1,2,2,0,0,1,1.14-.31,1.86,1.86,0,0,1,.84.18,1.64,1.64,0,0,1,.6.51,2.35,2.35,0,0,1,.35.9L12,7.05a1.84,1.84,0,0,0-.27-.68A1.17,1.17,0,0,0,11.29,6a1.55,1.55,0,0,0-1.41.11,1.61,1.61,0,0,0-.56.72A3.07,3.07,0,0,0,9.11,8a2.48,2.48,0,0,0,.45,1.62,1.47,1.47,0,0,0,1.17.53,1.7,1.7,0,0,0,.71-.16A1.79,1.79,0,0,0,12,9.64v-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack356);
export default __webpack_public_path__ + "static/media/Symbol_pack_356.81502372c637d2ff969973a0bfb24d4a.svg";
export { ForwardRef as ReactComponent };